module.exports = __webpack_public_path__ + "img/375.905f44f6.jpg";